import MerakiSDK from "@urbanpiper-engineering/meraki-sdk";
import { UserState } from "@urbanpiper-engineering/meraki-sdk/dist/esm/user/states/user.state";
import { useRouter } from "next/router";
import configSelector from "../external/configSelector";
import { useEffect } from "react";

const useLanguage = () => {
  const router = useRouter();
  const useUserState = MerakiSDK.getUserState().hook();

  const setLanguage = useUserState(
    (state: typeof UserState) => state.setLanguage,
  );
  const activeLanguageInState = useUserState(
    (state: typeof UserState) => state.language,
  );
  const defaultLanguage = router.locale || configSelector.getDefaultLanguage();

  useEffect(() => {
    if (activeLanguageInState) {
      setLanguage && setLanguage(defaultLanguage);
      setCookie(defaultLanguage);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultLanguage]);

  useEffect(() => {
    if (activeLanguageInState === "ar") {
      document.dir = "rtl";
    } else {
      document.dir = "ltr";
    }
  }, [activeLanguageInState]);

  const setCookie = (locale: string) => {
    document.cookie = `NEXT_LOCALE=${locale};max-age=31536000;path=/;SameSite=None;Secure`;
  };

  const updateLocalLanguage = async (lang: string) => {
    try {
      setLanguage(lang);
      setCookie(lang);

      const freshChatService = await MerakiSDK.getFreshChat();
      freshChatService.updateLanguage(lang);
    } catch (error) {
      console.error("updateLocalLanguage: ", { error });
    } finally {
      router.reload();
    }
  };

  return updateLocalLanguage;
};

export default useLanguage;
